import styled from 'styled-components';

import { GlareEffect } from '@sorare/core/src/atoms/animations/GlareEffect';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { NeonEdge as NeonEdgeAtom } from '@sorare/core/src/atoms/ui/NeonEdge';
import {
  desktopAndAbove,
  laptopAndAbove,
} from '@sorare/core/src/style/mediaQuery';
import { borderGradientStyle } from '@sorare/core/src/style/utils';

export const SeriesCardPackGroupWrapper = styled.div`
  display: block;
  width: 100%;
  background:
    linear-gradient(
      180deg,
      rgba(14, 14, 14, 0.5) 0%,
      rgba(14, 14, 14, 0.9) 79.85%,
      #0e0e0e 99.69%
    ),
    var(--background-image) top left / cover no-repeat;
  border-radius: var(--double-unit);
  --border-gradient: linear-gradient(
    to bottom,
    var(--league-color) 0%,
    transparent 20%
  );
  ${borderGradientStyle};
  overflow: hidden;

  @container ${laptopAndAbove} {
    width: auto;
    background: none;
    border: none;
    border-radius: 0;
    overflow: auto;
    position: relative;
    isolation: isolate;
    display: block;
    height: 100%;
  }
`;

export const Grid = styled.div`
  display: grid;
  padding-top: var(--double-unit);
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: var(--double-unit);
  @container ${laptopAndAbove} {
    display: none;
  }
`;

export const MainPack = styled(Vertical)`
  grid-column: span 2;
  width: 100%;
  gap: var(--triple-unit);
`;

export const SecondaryPack = styled.div`
  grid-column: span 1;
  border: 1px solid var(--c-nd-100);
  border-radius: var(--double-unit);
  padding: var(--double-unit);
`;
export const Header = styled.div`
  text-align: center;
  padding-bottom: var(--double-unit);
  border-bottom: 1px solid var(--c-nd-150);
  @container ${laptopAndAbove} {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const Logo = styled.img`
  width: 100%;
  max-width: calc(20 * var(--unit));
  height: calc(8 * var(--unit));
  object-fit: contain;
  object-position: center;
`;

export const NeonEdge = styled(NeonEdgeAtom)`
  width: 100%;
  padding: var(--double-unit);
  height: 100%;
`;

export const Desktop = styled.div`
  display: none;
  @container ${laptopAndAbove} {
    display: block;
  }
`;

export const PacksWrapper = styled(Horizontal)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(50%);
  bottom: 20%;
  z-index: -1;
  .wide & {
    bottom: 30%;
  }
  @container ${desktopAndAbove} {
    bottom: 30%;
  }
  > *:first-child {
    transform: scale(0.85);
    margin-right: -48px;
  }
  > *:last-child {
    z-index: -1;
    margin-left: -48px;
    transform: scale(0.85);
  }
`;

export const PackImg = styled(GlareEffect)`
  object-fit: contain;
  height: 100%;
  width: calc(16 * var(--unit));
`;

export const PlayersImg = styled.img`
  display: none;
  z-index: -1;
  .wide & {
    display: block;
    width: 100%;
    max-height: 200px;
    object-fit: contain;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) translateY(50%);
    bottom: 60%;
  }
  @container ${desktopAndAbove} {
    display: block;
    width: 250px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) translateY(50%);
    bottom: 60%;
  }
`;
